import React, { useState, useEffect, useMemo } from "react";
import { useAsync, IfRejected, IfPending, IfFulfilled } from "react-async";
import "../../App.css";
import "../LogInContainer/LogInContainer.css";
import Axios from "axios";
import FaceSheet from "../Forms/FaceSheet";
import FosterChecklist from "./FosterChecklist";
import { Col } from "react-bootstrap";

const fetchAllClientsInit = async ({ homeId }) => {
  return await Axios.get(`/api/client/${homeId}`);
};

const doDeleteClient = async ([homeId, clientId, active]) => {
  return await Axios.put(`/api/client/${homeId}/${clientId}`, {
    active,
  });
};

const fetchAllClients = async ([homeId]) => {
  return await Axios.get(`/api/client/${homeId}`);
};

const Clients = ({ showClientForm, userObj, doToggleClientDisplay }) => {
  const [showClients, setShowClients] = useState(showClientForm);
  const [selectedView, setSelectedView] = useState("facesheet");
  const [isClientSelected, setIsClientSelected] = useState(false);
  const [isInit, setIsInit] = useState(true);
  const [selectedClient, setSelectedClient] = useState(null);
  const [clients, setClients] = useState([]);
  const [showActive, setShowActive] = useState(true);

  useEffect(() => {
    if (showClientForm) {
      setIsClientSelected(false);
      setSelectedClient(null);
      setSelectedView("facesheet");
    }

    setShowClients(showClientForm);

    if (showClientForm && !isInit) {
      getAllClients.run([userObj.homeId]);
    }

    setIsInit(false);
  }, [showClientForm]);

  const getAllClients = useAsync({
    promiseFn: fetchAllClientsInit,
    homeId: userObj.homeId,
    deferFn: fetchAllClients,
    onResolve: (data) => {
      setClients(data.data);
    },
  });

  // The server always returns every client for the home regardless of
  // active status, so switching tabs only needs to re-filter data already
  // in memory - refetching here would leave the previous tab's list on
  // screen until the round-trip finished.
  const visibleClients = useMemo(() => {
    if (showActive === true) {
      return clients.filter((client) => {
        return !client.hasOwnProperty("active") || client.active === true;
      });
    } else {
      return clients.filter((client) => {
        return client.active === false;
      });
    }
  }, [clients, showActive]);

  const deleteClient = useAsync({
    deferFn: doDeleteClient,
    onResolve: (data) => {
      getAllClients.run([userObj.homeId]);
    },
  });

  const setClient = (value, view) => {
    setIsClientSelected(true);
    doToggleClientDisplay(false);
    setSelectedClient(value);
    setSelectedView(view);
  };

  const deleteClientCall = async (value, active) => {
    if (
      window.confirm(
        `Are you sure you want to ${
          active ? "activate" : "deactivate"
        } this client?`
      )
    ) {
      await deleteClient.run(userObj.homeId, value._id, active);
      doToggleClientDisplay(true);
    }
  };

  const toggleClientFilter = async (value) => {
    if (value !== showActive) {
      await setShowActive(value);
    }
  };

  if (showClients) {
    return (
      <div className="formCompNoBg">
        <div className="formTitleDiv">
          <h2 className="formTitle">Clients</h2>
        </div>
        <div className="formFieldsMobile">
          <div style={{ height: "25px" }}>
            <IfPending>
              <h4>Loading...</h4>
            </IfPending>
            <IfFulfilled state={getAllClients}>
              <h4>
                {visibleClients.length} {showActive ? "Active" : "Inactive"} Clients
              </h4>
            </IfFulfilled>
          </div>
          <div
            className="form-group logInInputField d-flex mt-3 justify-content-center"
            style={{ alignItems: "center" }}
          >
            <h5 style={{ margin: "0px 10px" }}>Filter</h5>
            <button
              onClick={() => {
                toggleClientFilter(true);
              }}
              className={`btn ${showActive ? "btn-light" : ""} extraInfoButton`}
            >
              Active
            </button>
            <button
              onClick={() => {
                toggleClientFilter(false);
              }}
              className={`btn ${
                showActive ? "" : "btn-light"
              } extraInfoButton `}
            >
              Inactive
            </button>
          </div>
          <div className="form-group logInInputField d-flex mt-3 border-bottom">
            <Col className="control-label">
               <label style={{ fontWeight: "bold" }}>Actions</label>
            </Col>
            <Col className="control-label">
              <label>Name</label>
            </Col>
            <Col>
              <label className="control-label">Date of Admission</label>
            </Col>
          </div>
          {visibleClients.map((client) => (
            <div className="form-group logInInputField d-flex mt-3" key={client._id}>
              <Col className="control-label d-flex">
                <button
                  className="btn btn-light extraInfoButton"
                  onClick={() => {
                    setClient(client, "facesheet");
                  }}
                >
                  Open
                </button>
                <button
                  className="btn btn-light extraInfoButton ml-2"
                  onClick={() => {
                    setClient(client, "checklist");
                  }}
                >
                  Checklist
                </button>
                <button
                  className="btn btn-link extraInfoButton"
                  onClick={() => {
                    deleteClientCall(client, !showActive);
                  }}
                >
                  <span
                    style={{
                      textDecoration: "none",
                      color: "#444",
                      cursor: "pointer",
                    }}
                  >
                    {showActive ? "Deactivate" : "Activate"}
                  </span>
                </button>
              </Col>
              <Col className="control-label">
                <label>{client.childMeta_name}</label>
              </Col>
              <Col>
                <label className="control-label">
                  {client.childMeta_dateOfAdmission}
                </label>
              </Col>
            </div>
          ))}
        </div>
      </div>
    );
  } else {
    return (
      <div className="formCompNoBg">
        <div className="formTitleDiv">
          <h2 className="formTitle">Clients</h2>
        </div>
        <IfRejected state={getAllClients}>
          <p>Error</p>
        </IfRejected>
        <IfPending state={getAllClients}>
          <p>Loading...</p>
        </IfPending>
        <IfFulfilled state={getAllClients}>
          <>
            {selectedView === "facesheet" && (
              <FaceSheet
                valuesSet={isClientSelected}
                userObj={userObj}
                id="facesheet"
                formData={selectedClient}
              />
            )}

            {selectedView === "checklist" && (
              <FosterChecklist
                valuesSet={isClientSelected}
                userObj={userObj}
                formData={selectedClient}
              />
            )}
          </>
        </IfFulfilled>
      </div>
    );
  }
};

export default Clients;
